import React, { useState } from 'react';
import { Tabs, Tab, Box, Card, CardContent, Button } from '@mui/material';
import SeminalFluidAnalysis from './seminalFluidAnalysis';
import PostWashAnalysis from './postWashAnalysis';
import PatientDetails from './patientDetails';
import SemenAnalysis from './semenAnalysis';
import { styled } from '@mui/system';
import OtherDetails from './otherDetails';
import QualityAnalysis from './qualityAnalysis';
import { useDispatch, useSelector } from 'react-redux';
import {
  createQSAReport,
  generateQSAReport,
  updateQSAReport,
} from '../../../../api/andrologyApi';
import {
  resetAndrologyData,
  setAndrologyData,
} from '../../../../actions/andrologyAction';
import { pollFileAvailability } from '../../../../api/utils';
import { checkFileAvailabilityApi } from '../../../../api/patientApi';
import axios from 'axios';
import { toast } from 'sonner';
import UIModal from '../../../../components/UIElements/UIModal';
const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  borderRadius: '8px',
}));

const StyledBox = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(3),
  border: '1px solid #ddd',
  borderRadius: '8px',
}));

export default function QsaReport({ setIsReportSelected }) {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const selectedPatientData = useSelector(
    (state) => state.andrologyReducer.selectedPatientData,
  );
  const qsaData = useSelector((state) => state.andrologyReducer.qsa);

  const dispatch = useDispatch();
  const handleSave = async () => {
    const res = await createQSAReport(selectedPatientData.patient.id, {
      ...qsaData,
      id: undefined,
    });
    dispatch(setAndrologyData('qsa', res.data));
  };

  const handleUpdate = async () => {
    const res = await updateQSAReport(selectedPatientData.patient.id, qsaData);
    dispatch(setAndrologyData('qsa', res.hsa));
  };

  const handleNext = () => {
    if (selectedTab < 4) {
      setSelectedTab((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (selectedTab > 0) {
      setSelectedTab((prev) => prev - 1);
    }
  };
  const [isDownloadDisabled, setIsDownloadDisabled] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const handleGenerateReport = async () => {
    setIsDownloadDisabled(true);
    const res = await generateQSAReport(
      selectedPatientData.patient.id,
      qsaData.id,
    );
    if (res && res.pdf && res.pdf.file) {
      // dispatch(resetAndrologyData());
      setIsDownloadDisabled(false);
      toast.success('Report Generated');
      try {
        const presignedUrl = await pollFileAvailability(
          checkFileAvailabilityApi,
          res.pdf.file.bucketName,
          res.pdf.file.fileKey,
        );
        dispatch(setAndrologyData('qsa.reportId', res.pdf.file.id));
        downloadFile(presignedUrl, selectedPatientData.patient.id);
        toast.success('Report is downloaded successfully');
        dispatch(setAndrologyData('refresh', true));
      } catch (error) {
        setIsDownloadDisabled(false);
        console.error('Failed to get presigned URL:', error);
      }
    }
  };

  const downloadFile = async (presignedUrl, patientId) => {
    try {
      const response = await axios.get(presignedUrl, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${patientId}-qsa-report.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading the file', error);
    }
  };

  const handleCancelStartReport = () => {
    setOpenConfirmModal(false);
  };

  const saveAndNext = () => {
    if (!qsaData.id) {
      handleSave();
    } else {
      handleUpdate();
    }
    handleNext();
  };
  return (
    <div className="theme-blush">
      <StyledCard>
        <CardContent>
          <StyledBox>
            <Tabs
              value={selectedTab}
              onChange={handleChange}
              aria-label="HSA Report Tabs"
            >
              <Tab label="Patient Details" />
              <Tab label="Seminal Fluid Analysis" />
              <Tab label="Sperm Analysis" />
              <Tab label="Quality Analysis" />
              <Tab label="Other Details" />
            </Tabs>
            <Box mt={2}>
              {selectedTab === 0 && (
                <PatientDetails keyPath={'qsa.patientDetails'} />
              )}
              {selectedTab === 1 && (
                <SeminalFluidAnalysis keyPath={'qsa.seminalFluidAnalysis'} />
              )}
              {selectedTab === 2 && (
                <SemenAnalysis keyPath={'qsa.spermAnalysis'} />
              )}
              {selectedTab === 3 && (
                <QualityAnalysis keyPath={'qsa.qualityAnalysis'} />
              )}
              {selectedTab === 4 && (
                <OtherDetails keyPath={'qsa.otherDetails'} />
              )}
            </Box>
            <Box
              mt={4}
              display={'flex'}
              flexDirection={'row'}
              gap={'12px'}
              justifyContent={'end'}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setIsReportSelected(false);
                }}
                style={{ minWidth: '180px' }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleBack}
                disabled={selectedTab === 0}
                style={{ minWidth: '180px' }}
              >
                Back
              </Button>
              {selectedTab != 4 ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={saveAndNext}
                  style={{ minWidth: '180px' }}
                >
                  Save And Next
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={saveAndNext}
                  style={{ minWidth: '180px' }}
                >
                  Save
                </Button>
              )}
              {/* {!qsaData.id && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                  style={{ minWidth: '180px' }}
                >
                  Save
                </Button>
              )}
              {qsaData.id && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleUpdate}
                  style={{ minWidth: '180px' }}
                >
                  Save
                </Button>
              )} */}
              {selectedTab === 4 && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setOpenConfirmModal(true)}
                  style={{ minWidth: '180px' }}
                  disabled={isDownloadDisabled}
                >
                  Generate Report
                </Button>
              )}
            </Box>
          </StyledBox>
        </CardContent>
      </StyledCard>
      <UIModal
        title="Please confirm?"
        body="Do you want to generate report? Report once generated can't be changed. Do you still want to go ahead?"
        proceedText="Confirm"
        cancelText="Cancel"
        show={openConfirmModal}
        onClose={() => handleCancelStartReport()}
        onSave={() => {
          handleGenerateReport();
          setOpenConfirmModal(false);
        }}
      />
    </div>
  );
}
